module.exports = __webpack_public_path__ + "img/introduce-icon2.caa2bda7.svg";